import { ADICIONAR_FILTRO_ROTA } from '../types'

export default function adicionarFiltroRota (filtro) {
  return {
    type: ADICIONAR_FILTRO_ROTA,
    payload: filtro
  }
}
